(function () {
  'use strict';

  var scriptId = 'hg-stamped-widget-script';
  var stampedSource = 'https://cdn1.stamped.io/files/widget.min.js';
  var sectionObservers = new WeakMap();
  var sectionTimers = new WeakMap();

  function setStatus(section, message) {
    var status = section.querySelector('[data-hg-stamped-status]');
    if (!status) return;

    var nextMessage = message || '';
    var nextHidden = !nextMessage;
    if (status.textContent !== nextMessage) status.textContent = nextMessage;
    if (status.hidden !== nextHidden) status.hidden = nextHidden;
  }

  function getReviewCards(section) {
    return Array.prototype.slice.call(
      section.querySelectorAll('.stamped-review, .stamped-review-card')
    );
  }

  function revealStampedReviews(section) {
    if (!getReviewCards(section).length) return false;
    section.classList.add('hg-all-reviews--ready');
    setStatus(section, '');
    return true;
  }

  function scheduleReviewUpdate(section) {
    var previousTimer = sectionTimers.get(section);
    if (previousTimer) window.clearTimeout(previousTimer);

    sectionTimers.set(section, window.setTimeout(function () {
      revealStampedReviews(section);
    }, 80));
  }

  function watchForReviews(section) {
    revealStampedReviews(section);

    var previousObserver = sectionObservers.get(section);
    if (previousObserver) previousObserver.disconnect();

    var observer = new MutationObserver(function () {
      scheduleReviewUpdate(section);
    });
    observer.observe(section, { childList: true, subtree: true });
    sectionObservers.set(section, observer);
  }

  function initializeStamped(section) {
    if (!section || !window.StampedFn) return;

    if (section.getAttribute('data-hg-stamped-initialized') !== 'true') {
      section.setAttribute('data-hg-stamped-initialized', 'true');
      window.StampedFn.init({
        apiKey: section.getAttribute('data-stamped-api-key'),
        sId: section.getAttribute('data-stamped-store-id')
      });
    }

    watchForReviews(section);
  }

  function loadStamped(section) {
    if (window.StampedFn) {
      initializeStamped(section);
      return;
    }

    var existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.addEventListener('load', function () {
        initializeStamped(section);
      }, { once: true });
      return;
    }

    var script = document.createElement('script');
    script.id = scriptId;
    script.src = stampedSource;
    script.async = true;
    script.addEventListener('load', function () {
      initializeStamped(section);
    }, { once: true });
    script.addEventListener('error', function () {
      setStatus(section, '');
    }, { once: true });
    document.head.appendChild(script);
  }

  function start() {
    var sections = document.querySelectorAll('[data-hg-stamped-reviews]');
    Array.prototype.forEach.call(sections, loadStamped);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
